import React, { useState } from "react";
import Navbar from "../navbar";
import Footer from "../footer";
import "./style.scss";
import { Link } from "gatsby";
import QuickEnquiry from "../connectpage/hospitality";
import Clients from "../clients";

import chirochargeimg from "../../images/hospitality/Chiro Charge.jpg";
import chirochargePTimg from "../../images/hospitality/Chiro Charge pt.jpg";
import chiroEliteimg from "../../images/hospitality/Chiro Elite.jpg";
import chirocoilimg from "../../images/hospitality/CHIRO COIL.jpg";

import premiumFibre from "../../images/pillows/Premium-Fibre-Pillow5 2.png";
import latexPillow from "../../images/pillows/Latex-Pillow 2.png";
import memoryFoamPillow from "../../images/pillows/Memory-Foam-Pillow 2.png";
import royalePillow from "../../images/pillows/Royal-Pillow 2.png";
import microFibrePillow from "../../images/pillows/Micro-Fibre-Pillow 2.png";
import gelPillow from "../../images/pillows/Gel-Pillow 2.png";

import ActionPopup from "../actionpopup";

import SEO from "../seo";

export default function HospitalityPage() {
  const [showForm, setShowForm] = useState(false);
  const [showActionToAccess, setShowActionToAccess] = useState(false);

  function toggleForm() {
    setShowForm(!showForm);
  }

  const data = [
    {
      quote: `"Innovative and high quality products backed by prompt service by Eclipse International has helped us provide our customers a comfortable and complete sleep experience. I highly recommend mattress and products by Eclipse as they offer superior quality at value-for-money pricing."`,
      name: "Mr. Vivek Shukla",
      designation: "General Manager,<br/>Ramada By Wyndham Darjeeling",
    },
    {
      quote: `"The products and services provided more than satisfy our high demands. We would like to specially appreciate your efforts of going out of the way in making timely deliveries and co-operating with us at every given time. We are delighted to be associated with you in business."`,
      name: "Mr. K.C. Bahuguna",
      designation: "Associate Director Purchase,<br/>The Park",
    },
    {
      quote: `"This is to comment that Eclipse Mattresses are superior in quality and we are very much satisfied with their services. Kaizen and innovation is their philosophy."`,
      name: "Rajyalakshmi Ghosh",
      designation: "Executive Housekeeper, <br/>Jaypee Vasant Continental",
    },
    {
      quote: `"We have been using mattress and other products from Eclipse International since 2014 and the quality of the products is very good and long lasting. We have been getting lots of positive feedback from our esteemed guests about the quality of mattresses and other products."`,
      name: "Teck Bahadur Beersingh Sarke",
      designation: "Material Manager, <br/>Sahara Star",
    },
  ];

  return (
    <div className="hospitality">
      <SEO
        title="Hospitality Series | Signature Luxury Mattresses | Eclipse International"
        description="Luxurious bedding solutions and handcrafted mattresses used by the world’s leading hotel brands. Download the Eclipse Hospitality Catalog today."
        img="https://eclipsemattress.in/assets/linkpreviews/category/hospitality-series.jpg"
      />
      {showForm && (
        <div className="hospitality__quickenquiry">
          <h1>Quick Enquiry</h1>

          <button
            onClick={toggleForm}
            className="hospitality__quickenquiry__close"
          >
            {" "}
            <i className="fas fa-times"></i>
          </button>
          <QuickEnquiry />
        </div>
      )}
      <Navbar />
      <img
        className="hospitality__banner desktop"
        alt="Hospitality banner"
        src="https://eclipsemattress.in/assets/images/banners/hospitality-d.jpeg"
      />
      <img
        className="hospitality__banner mobile"
        alt="Hospitality banner"
        src="https://eclipsemattress.in/assets/images/banners/hospitality-m.jpg"
      />
      <div className="hospitality__content">
        <h1 className="heading-primary">Hospitality Series</h1>
        <div className="hospitality__description">
          Since 1905 Eclipse International Mattress company has been servicing
          hoteliers around the world. Our impressive list of alliances among
          many include Marriott International Corporation, Intercontinental
          Hotels Group (Holiday Inn Express), Choice Hotels and Best Western. We
          are the holistic bedding solution for hotels, raising your bedding
          standards and elevating overall client satisfaction. Join the brand
          already appreciated in 60 countries and give world class comfort to
          your clients.
        </div>

        <ActionPopup
          link="https://eclipsemattress.in/assets/pdfs/Hospitality-Collection.pdf"
          category="Hospitality Series"
          showPopup={showActionToAccess}
          onClose={() => {
            setShowActionToAccess(false);
          }}
        />

        <div className="hospitality__buttons">
          <button onClick={toggleForm} className="hospitality__buttons__btn">
            Quick Enquiry
          </button>
          <button
            className="btn-primary"
            onClick={() => {
              setShowActionToAccess(true);
            }}
          >
            Brochure <i class="fas fa-download"></i>
          </button>
        </div>

        <div className="hospitality__collection">
          <div className="heading-secondary">Collection</div>
          <br />

          <div className="row">
            <div className="col col-12  col-md-6">
              <Link to="/hospitality/chiro-elite/">
                <div className="hospitality__collection__product">
                  <div className="hospitiality__collection__product__img">
                    <img alt="Product Image" src={chiroEliteimg}></img>
                    <div className="hospitality__collection__product__name">
                      Chiro Elite
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col col-12  col-md-6">
              <Link to="/hospitality/chiro-charge/">
                <div className="hospitality__collection__product">
                  <div className="hospitiality__collection__product__img">
                    <img alt="Product Image" src={chirochargeimg}></img>
                    <div className="hospitality__collection__product__name">
                      Chiro Charge
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col col-12  col-md-6">
              <Link to="/hospitality/chiro-charge-pt/">
                <div className="hospitality__collection__product">
                  <div className="hospitiality__collection__product__img">
                    <img alt="Product Image" src={chirochargePTimg}></img>
                    <div className="hospitality__collection__product__name">
                      Chiro Charge PT
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col col-12  col-md-6">
              <Link to="/hospitality/chiro-coil/">
                <div className="hospitality__collection__product">
                  <div className="hospitiality__collection__product__img">
                    <img alt="Product Image" src={chirocoilimg}></img>
                    <div className="hospitality__collection__product__name">
                      Chiro Coil
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <br />

          <div className="hospitality__collection__accessories">
            <div className="heading-secondary">Accessories</div>

            <div className="hospitality__collection__accessory__heading">
              Pillows
            </div>

            <div className="row">
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img">
                      <img
                        alt="Accessory"
                        // src="https://eclipsemattress.in/wp-content/uploads/2019/12/Premium-Fibre-Pillow.jpg"
                        src={premiumFibre}
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Premium Fibre Pillow
                      </div>
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img">
                      <img
                        alt="Accessory"
                        // src="https://eclipsemattress.in/wp-content/uploads/2019/12/Latex-Pillow.jpg"
                        src={latexPillow}
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Latex Pillow
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img">
                      <img
                        alt="Accessory"
                        // src="https://eclipsemattress.in/wp-content/uploads/2019/12/Royal-Pillow.jpg"
                        src={royalePillow}
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Royale Pillow
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img">
                      <img
                        alt="Accessory"
                        // src="https://eclipsemattress.in/wp-content/uploads/2019/12/Memory-Foam-Pillow.jpg"
                        src={memoryFoamPillow}
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Memory Foam Pillow
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img">
                      <img
                        alt="Accessory"
                        // src="https://eclipsemattress.in/wp-content/uploads/2019/12/Micro-Fibre-Pillow.jpg"
                        src={microFibrePillow}
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Micro Fibre Pillow
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img">
                      <img
                        alt="Accessory"
                        // src="https://eclipsemattress.in/wp-content/uploads/2019/12/Gel-Pillow.jpg"
                        src={gelPillow}
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Gel Pillow
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>

            <div className="hospitality__collection__accessory__heading">
              Head Boards
            </div>

            <div className="row">
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img hospitiality__collection__accessory__img--2">
                      <img
                        alt="Accessory"
                        src="https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board4.jpg"
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Boston
                      </div>
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img hospitiality__collection__accessory__img--2">
                      <img
                        alt="Accessory"
                        src="https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board3.jpg"
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Ritz
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img hospitiality__collection__accessory__img--2">
                      <img
                        alt="Accessory"
                        src="https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board2.jpg"
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Toree
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col col-12  col-md-3">
                <Link>
                  <div className="hospitality__collection__accessory">
                    <div className="hospitiality__collection__accessory__img hospitiality__collection__accessory__img--2">
                      <img
                        alt="Accessory"
                        src="https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board.jpg"
                      ></img>
                      <div className="hospitality__collection__accessory__name">
                        Windsor
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <Clients testimonials={data} isHospitality />
      </div>
      <Footer />
    </div>
  );
}
